module.exports = __webpack_public_path__ + "media/images/room_monitor/wash_vacancy-28e920ae30b31468a6a66fe85b92b5d4.png";